import { ENV } from "../utils";

export class Evidence {
  baseApi = ENV.BASE_API;

  async getEvidences(accessToken, active = true) {
    const url = `${this.baseApi}/evidences?active=${active}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createEvidence(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-evidence`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateEvidence(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-evidence/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteEvidence(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-evidence/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
